import React from 'react';

/**
 * Bootstrap 4 connected pagination: Previous | 1 | 2 | … | 32 | Next
 */
export default function PaginationBar({
  page,
  totalPages,
  total,
  pageSize = 20,
  onPageChange,
  disabled = false,
}) {
  const pages = Math.max(1, totalPages || Math.ceil(total / pageSize) || 1);
  if (total <= 0) return null;

  const go = (p) => {
    if (disabled || p < 1 || p > pages || p === page) return;
    onPageChange(p);
  };

  const maxButtons = 5;
  let start = Math.max(1, page - 2);
  let end = Math.min(pages, start + maxButtons - 1);
  start = Math.max(1, end - maxButtons + 1);

  const pageNumbers = [];
  for (let i = start; i <= end; i += 1) pageNumbers.push(i);

  const showLeadingEllipsis = start > 1;
  const showTrailingEllipsis = end < pages - 1;
  const showLastPage = pages > 1 && end < pages;

  return (
    <ul className="pagination pagination-sm mb-0 justify-content-end">
      <li className={`page-item ${page <= 1 || disabled ? 'disabled' : ''}`}>
        <button
          type="button"
          className="page-link"
          onClick={() => go(page - 1)}
          disabled={page <= 1 || disabled}
        >
          Previous
        </button>
      </li>

      {showLeadingEllipsis && (
        <>
          <li className={`page-item ${page === 1 ? 'active' : ''}`}>
            <button type="button" className="page-link" onClick={() => go(1)} disabled={disabled}>
              1
            </button>
          </li>
          <li className="page-item disabled">
            <span className="page-link">…</span>
          </li>
        </>
      )}

      {pageNumbers.map((p) => {
        if (showLeadingEllipsis && p === 1) return null;
        if (showLastPage && p === pages) return null;
        return (
          <li key={p} className={`page-item ${p === page ? 'active' : ''}`}>
            <button type="button" className="page-link" onClick={() => go(p)} disabled={disabled}>
              {p}
            </button>
          </li>
        );
      })}

      {showTrailingEllipsis && (
        <li className="page-item disabled">
          <span className="page-link">…</span>
        </li>
      )}

      {showLastPage && (
        <li className={`page-item ${page === pages ? 'active' : ''}`}>
          <button type="button" className="page-link" onClick={() => go(pages)} disabled={disabled}>
            {pages}
          </button>
        </li>
      )}

      <li className={`page-item ${page >= pages || disabled ? 'disabled' : ''}`}>
        <button
          type="button"
          className="page-link"
          onClick={() => go(page + 1)}
          disabled={page >= pages || disabled}
        >
          Next
        </button>
      </li>
    </ul>
  );
}
